<template>
  <v-container>
    <v-card>
      <v-card-title>
        {{ $t("Shaxsiy ma’lumotlar") }}
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-img
              :src="application.photo"
              max-width="250"
              class="mb-4"
              alt="Rasm"
            />
            <v-img
              v-for="(img, index) in application.passportPhotos"
              :key="index"
              :src="img"
              max-width="250"
              class="mb-4"
              alt="Passport image"
            />
          </v-col>

          <v-col cols="12" md="8">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>{{ $t("Ism") }}:</strong> {{ application.firstName }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>{{ $t("Familiya") }}:</strong> {{ application.lastName }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>{{ $t("Sharifi") }}:</strong> {{ application.middleName }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>{{ $t("Passport") }}:</strong> {{ application.passport }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>JSHSHIR:</strong> {{ application.jshshir }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>{{ $t("Telefon") }}:</strong> {{ application.phone }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>{{ $t("Tug'ilgan sanasi") }}:</strong> {{ application.birthDate }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>{{ $t("Manzil") }}:</strong> {{ application.address }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-divider class="my-5"></v-divider>

        <v-row>
          <v-col cols="12" md="6">
            <h3>{{ $t("Ta’lim yo'nalishi") }}</h3>
            <p>{{ application.eduDirection }}</p>
            <p>{{ $t("Ta’lim turi") }}: {{ application.eduType }}</p>
            <p>{{ $t("Ta’lim tili") }}: {{ application.language }}</p>
          </v-col>
          <v-col cols="12" md="6">
            <h3>{{ $t("Bakalavr ta’lim ma’lumotlari") }}</h3>
            <v-img
              v-for="(img, index) in application.bachelorDiplomas"
              :key="index"
              :src="img"
              max-width="200"
              class="mb-2"
            />
            <p>{{ $t("Hujjat turi") }}: {{ application.documentType }}</p>
            <p>{{ $t("Oliy ta’lim nomi") }}: {{ application.university }}</p>
            <p>{{ $t("O'qigan ta’lim yo'nalishi") }}: {{ application.prevEduDirection }}</p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    application() {
      return this.$store.getters["admin-masters/GET_APPLICATION"] || {};
    },
  },
};
</script>

<style scoped>
h3 {
  font-weight: 600;
}
</style>